var getCategoryByUrlId = function(categories, urlId) {
    return categories.find(function(category) {
        return category.url_id === urlId;
    });
};
/**
 * Will return the category which most deeply matches the URL IDs provided
 *
 * For example in a tree like so below
 *
 * - Home Decor
 * - - Pillows
 * - - - Throw Pillows
 *
 * urlIds = ["Home Decor", "Pillows", "Throw Pillows"] will return the Throw Pillows category
 * urlIds = ["Home Decor", "Pillows"] will return the Pillows category
 * urlIds = ["Home Decor"] will return the Home Decor category
 * urlIds = ["Home Decor", "Pillows", "Throw Pillows", "Extra"] will return the Throw Pillows category
 * urlIds = ["Home Decor", "Pillows", "Extra"] will return the Pillows category
 * urlIds = ["Home Decor", "Extra"] will return the Home Decor category
 * urlIds = ["Extra"] will return undefined
 */ export var findClosestActiveCategoriesByUrlIds = function(urlIds, categoriesToSearch) {
    var matchedCategories = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = urlIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var urlId = _step.value;
            var category = getCategoryByUrlId(categoriesToSearch !== null && categoriesToSearch !== void 0 ? categoriesToSearch : [], urlId);
            if (category === undefined) {
                return matchedCategories;
            }
            matchedCategories.push(category);
            categoriesToSearch = category.sub_categories;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return matchedCategories;
};
/**
 * Will return the category which most deeply matches the URL IDs provided
 *
 * See findClosestActiveCategoriesByUrlIds for more details
 */ export var findClosestActiveCategoryByUrlIds = function(urlIds, categoriesToSearch) {
    var activeCategories = findClosestActiveCategoriesByUrlIds(urlIds, categoriesToSearch);
    return activeCategories[activeCategories.length - 1];
};
/**
 * Returns the category which matches the URL IDs
 *
 * For example in a tree like so below
 *
 * - Home Decor
 * - - Pillows
 * - - - Throw Pillows
 *
 * urlIds = ["Home Decor", "Pillows", "Throw Pillows"] will return the Throw Pillows category
 * urlIds = ["Home Decor", "Pillows"] will return the Pillows category
 * urlIds = ["Home Decor"] will return the Home Decor category
 * urlIds = ["Home Decor", "Pillows", "Throw Pillows", "Extra"] will return undefined
 * urlIds = ["Home Decor", "Pillows", "Extra"] will return undefined
 * urlIds = ["Home Decor", "Extra"] will return undefined
 * urlIds = ["Extra"] will return undefined
 */ export var findActiveCategoryByUrlIds = function(urlIds, categoriesToSearch) {
    var matchedCategories = findClosestActiveCategoriesByUrlIds(urlIds, categoriesToSearch);
    if (matchedCategories.length === urlIds.length) {
        return matchedCategories[matchedCategories.length - 1];
    }
    return undefined;
};
